module.exports = __webpack_public_path__ + "img/360tour.7da2347.png";